import React from "react";
import Icon from "components/AppIcon";

const territories = [
  { id: "t1", name: "Downtown District", controller: "Iron Wolves", bonusType: "Revenue", bonusValue: 15, affectedSectors: ["retail", "financial"], color: "var(--color-primary)" },
  { id: "t2", name: "Industrial Zone", controller: "Steel Syndicate", bonusType: "Revenue", bonusValue: 20, affectedSectors: ["manufacturing"], color: "var(--color-accent)" },
  { id: "t3", name: "Tech Quarter", controller: "Nexus Corp", bonusType: "Revenue", bonusValue: 18, affectedSectors: ["tech"], color: "#A78BFA" },
  { id: "t4", name: "Harbor District", controller: "Shadow Fleet", bonusType: "Revenue", bonusValue: 25, affectedSectors: ["black_market"], color: "var(--color-error)" },
  { id: "t5", name: "Financial Hub", controller: "Uncontrolled", bonusType: "None", bonusValue: 0, affectedSectors: ["financial"], color: "var(--color-muted-foreground)" },
];

const sectorColors = {
  retail: "var(--color-primary)",
  tech: "#A78BFA",
  manufacturing: "var(--color-accent)",
  financial: "var(--color-success)",
  black_market: "var(--color-error)",
};

const TerritoryBonusPanel = ({ ownedSectors }) => {
  const relevantTerritories = territories?.filter(t =>
    t?.affectedSectors?.some(s => ownedSectors?.includes(s))
  );

  return (
    <div className="rounded-xl border p-4 md:p-5" style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}>
      <div className="flex items-center gap-2 mb-4">
        <Icon name="MapPin" size={16} color="var(--color-accent)" />
        <h3 className="font-heading text-sm font-semibold text-foreground">Territory Bonuses</h3>
        <span className="ml-auto font-caption text-xs text-muted-foreground">Faction control multipliers</span>
      </div>
      <div className="space-y-2">
        {relevantTerritories?.map(territory => (
          <div key={territory?.id} className="flex items-center gap-3 p-3 rounded-lg border transition-all duration-200" style={{ background: "rgba(255,255,255,0.02)", borderColor: territory?.bonusValue > 0 ? `${territory?.color}25` : "var(--color-border)" }}>
            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${territory?.color}15` }}>
              <Icon name={territory?.bonusValue > 0 ? "MapPin" : "Map"} size={14} color={territory?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-caption text-xs font-semibold text-foreground truncate">{territory?.name}</div>
              <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                <span className="font-caption text-xs text-muted-foreground">{territory?.controller}</span>
                <span className="text-muted-foreground text-xs">•</span>
                <div className="flex gap-1">
                  {territory?.affectedSectors?.filter(s => ownedSectors?.includes(s))?.map(s => (
                    <span key={s} className="font-caption text-xs px-1.5 py-0.5 rounded capitalize" style={{ background: `${sectorColors?.[s]}15`, color: sectorColors?.[s] }}>
                      {s?.replace("_", " ")}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 text-right">
              {territory?.bonusValue > 0 ? (
                <div className="flex items-center gap-1 px-2 py-1 rounded-md" style={{ background: "rgba(255,184,0,0.1)" }}>
                  <Icon name="TrendingUp" size={11} color="var(--color-accent)" />
                  <span className="font-heading text-xs font-bold" style={{ color: "var(--color-accent)" }}>+{territory?.bonusValue}%</span>
                </div>
              ) : (
                <span className="font-caption text-xs text-muted-foreground">No bonus</span>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 rounded-lg border" style={{ background: "rgba(0,217,255,0.05)", borderColor: "rgba(0,217,255,0.15)" }}>
        <div className="flex items-start gap-2">
          <Icon name="Info" size={13} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
          <p className="font-caption text-xs text-muted-foreground">
            Territory bonuses are applied automatically when your faction controls the district. Join or create a faction to compete for territory control and boost your business revenues.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TerritoryBonusPanel;